export enum ECheckAccountOwnerTypeEnum {
    Personal = "Personal",
    Business = "Business",
}
